export const tooltips = {
	// General Info tooltips
	sku:
		"SKU (Stock Keeping Unit) é um código único para identificar o produto. Se você não preencher, geraremos um automaticamente.",
	preparationTime: "Informe o tempo que leva para a cozinha preparar este produto",
	hasAlcohol: "Ao ativar irá aparecer no menu para os clientes que contém álcool",

	// Stock tooltips
	isStockable:
		"Produtos estocáveis são aqueles que ficam armazenados em estoque até serem vendidos ou utilizados.",
	conversionRule:
		"Defina como unidades de venda se convertem em unidades de estoque. Ex: 1 garrafa = 1 litro",

	// Fiscal Data tooltips
	ncm: "Nomenclatura Comum do Mercosul",
	cest: "Código Especificador de Substituição Tributária",
	fiscalProfile:
		"Conjunto de dados que descreve a situação fiscal de uma pessoa ou empresa.",
	fiscalGroup:
		"Grupo fiscal é um código que classifica produtos conforme sua tributação.",

	// Pricing tooltips
	variablePrice: "Preço variável: preço do produto será definido no PDV",
};
